import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../Assets/png/spaceship-alien.png";
import navIcon1 from "../Assets/png/icons8-instagram-48.svg";
import navIcon2 from "../Assets/png/icons8-twitter-48.svg";
import navIcon3 from "../Assets/png/icons8-linkedin-48.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://instagram.com/adnan_shelim?igshid=YmMyMTA2M2Y="><img src={navIcon1} alt="Icon" /></a>
              <a href="https://twitter.com/Adnan05272081"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.linkedin.com/in/adnan-mohammed-648052269"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Copyright 2023. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}